import { Link } from 'react-router-dom';
import './App.css';
import { motion } from "motion/react";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdEmail } from "react-icons/md";
function Contact() {
  return (
    <section id="contact" className="section">
      <motion.div className="contact-card"
      initial={{ scale:0.2 }}
      whileInView={{ scale:1}}
      transition={{ duration: 1.5 ,delay:0.1}}
      viewport={{once:true}}>
        <div>
          <h2>Let&apos;s build something great together</h2>
          <p className="section-text">
            I&apos;m available for freelance work, collaboration, and new opportunities.
          </p>
        </div>
        <div className='d-flex flex-column gap-3'>
          <Link to="mailto:alimhasan.9933@gmail.com">
          <MdEmail color='white' size={20}/> <span className='text-contact'>alimhasan.9933@gmail.com</span></Link>
          <Link to="https://wa.me/+963991333348" target="_blank" rel="noreferrer">
          <IoLogoWhatsapp  color='green' size={20}/> <span className='text-contact'>+963991333348</span></Link>
        </div>
      </motion.div>
    </section>
  );
}

export default Contact;
